var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useHistory } from "react-router-dom";
import { Button, MenuSection, Pane, ConfirmationModal, ErrorModal, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import TableComponent from "../../components/TableComponent";
import AgencyPrefixesDetail from "./AgencyPrefixesDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { useAgencyPrefixFilters } from "../../hooks/useAgencyPrefixFilters";
import { useAgencyPrefixesData } from "../../hooks/useAgencyPrefixesData";
import AgencyPrefixFilterPane from "../../components/AgencyPrefixFilterPane";
import { useAgencyPrefixActions } from "../../hooks/useAgencyPrefixActions";
import { useAgencyPrefixTable } from "../../hooks/useAgencyPrefixTable";
import { usePageSize } from "../../hooks/usePageSize";
var AgencyPrefixesList = function () {
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var filtersHook = useAgencyPrefixFilters();
    var _a = usePageSize(), pageSize = _a.pageSize, createPageSizeHandler = _a.createPageSizeHandler;
    var dataHook = useAgencyPrefixesData(filtersHook.filters, pageSize);
    var actionsHook = useAgencyPrefixActions();
    var columns = useAgencyPrefixTable(actionsHook.handleRowClick).columns;
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleAgencyChange = function (agency) {
        dataHook.resetPageOffset();
        filtersHook.handleAgencyChange(agency);
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    return (React.createElement(React.Fragment, null,
        actionsHook.isOpen && (React.createElement(ConfirmationModal, { open: actionsHook.isOpen, heading: formatMessage({
                id: "ui-br-agency.agency-prefix.modal.heading",
            }), message: actionsHook.message, onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, actionsHook.confirmDelete()];
                        case 1:
                            _a.sent();
                            dataHook.refetch();
                            return [2 /*return*/];
                    }
                });
            }); }, onCancel: actionsHook.closeModal, confirmLabel: formatMessage({ id: "ui-br-agency.button.delete" }), cancelLabel: formatMessage({ id: "ui-br-agency.button.cancel" }), buttonStyle: "primary" })),
        React.createElement(ErrorModal, { open: actionsHook.errorOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: actionsHook.errorMessage, onClose: function () { return actionsHook.setErrorOpen(false); } }),
        React.createElement(RecekPaneSet, null,
            React.createElement(AgencyPrefixFilterPane, { filterPaneIsVisible: filtersHook.filterPaneIsVisible, isAnyFilterActive: filtersHook.isAnyFilterActive, onClearFilters: handleClearFilters, filters: filtersHook.filters, onAgencyChange: handleAgencyChange }),
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.agency-prefix.table.title" }), paneSub: formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords }), actionMenu: function (_a) {
                    var onToggle = _a.onToggle;
                    return (React.createElement(MenuSection, { label: formatMessage({ id: "ui-br-agency.action.menu.label" }), id: "actions-menu" },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                onToggle();
                                history.push("/bragency/agency-prefixes/create");
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.button.create" }))));
                } },
                React.createElement(TableComponent, { data: dataHook.agencyPrefixesData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filtersHook.filterPaneIsVisible, toggleFilterPane: filtersHook.toggleFilterPane, source: dataHook.source })),
            actionsHook.selectedAgencyPrefix && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                    id: "ui-br-agency.agency-prefix.detail.pane.title",
                }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({ id: "ui-br-agency.action.menu.label" }), id: "actions-menu" },
                    React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            return actionsHook.openConfirm(actionsHook.selectedAgencyPrefix);
                        }, fullWidth: true },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.delete" })))); } },
                React.createElement(AgencyPrefixesDetail, { agencyPrefix: actionsHook.selectedAgencyPrefix }))))));
};
export default AgencyPrefixesList;
